import {
  AccessFunction,
  AccessFunctionFormData,
} from 'data/accessFunction/accessFunction.types';
import { Operation, WithAuditDetails } from 'data/types';
import { adaptToSubmit, setAccessFunctionOperationValues, setAdditionalMOOperation } from 'data/accessFunction/accessFunction.adapter';
import { Diameter } from 'data/diameter/diameter.types';

export default function getAccessFunctionDataToSubmit(
  accessFunctionFormData: AccessFunctionFormData,
  originalAccessFunction: AccessFunction | null,
  operation: Operation,
  accessFunctions?: AccessFunction[],
  fileLocationFormData?: { key: string; value: string; },
  diameter?: Diameter,
): WithAuditDetails<AccessFunction> {
  const adaptedFormData = adaptToSubmit(
    accessFunctionFormData,
    originalAccessFunction,
    operation,
    fileLocationFormData
  );

  const dataToSubmit = setAccessFunctionOperationValues(adaptedFormData, originalAccessFunction, operation);
  setAdditionalMOOperation(dataToSubmit, operation, accessFunctions, diameter);

  if (dataToSubmit.type === 'SIEMENS_LIMS') {
    // Sort all the delete operation to the top so it will execute first
    dataToSubmit.dataInterfaces?.sort((item1, item2) => {
      if (item1.operation === 'DELETE' && item2.operation !== 'DELETE') {
        return -1; // 'DELETE' should come first
      }
      if (item1.operation !== 'DELETE' && item2.operation === 'DELETE') {
        return 1; // 'DELETE' should come first
      }
      return 0;
    })
  }

  const accessFunctionBody: WithAuditDetails<AccessFunction> = {
    data: dataToSubmit,
  };

  if (operation === 'UPDATE') {
    accessFunctionBody.originalData = originalAccessFunction || null;
  }

  return accessFunctionBody;
}
